import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GeneralError } from '../../domain/errors/general'
import { Envs } from '../../envs'

export class DeleteShortLink {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(productId: string, shortLinkId: string): Promise<null> {
    const response = await this.httpClient.request({
      method: HttpMethod.DELETE,
      url: `${Envs.BFF_PRODUCT_URL}/products/${productId}/short-links/${shortLinkId}`,
    })

    if (response.statusCode === HttpStatusCode.NO_CONTENT) {
      return response.data
    }

    switch (response.data.errorCode) {
      default:
        throw new GeneralError()
    }
  }
}
